import { HttpClient } from "@angular/common/http";
import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { MessageService } from "primeng/api";
import { v4 as uuidv4 } from 'uuid';

import {
  DialogService,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { NGXLogger } from "ngx-logger";
import { Router } from "@angular/router";


import { UserService } from "src/app/services/user.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";

export let applicationVersionFromHome: string = "";

import { getDocs, onSnapshot } from "firebase/firestore";
import { environment } from "src/environments/environment";
import { StatsFlowdy2 } from "src/app/models/statsFlowdy2.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { ImportLog_Firestore } from "src/app/models/firestore/importLogFirestore.model";
import { Prontofibra_Firestore } from "src/app/models/prontofibra.firestore.model";
import { ExcelService } from "src/app/services/excelService.service";
import { ListeService } from "src/app/services/liste.service";
import { DialogCaricaCodiceBarre } from "../pratiche/flowdy2/shared/carica-codice-barre/carica-codice-barre.component";


declare const CSVBoxImporter: any;

@Component({
  selector: "app-home-dashboard",
  templateUrl: "./home.dashboard.flowdy2.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeDashboardFlowdy2Component implements OnInit, OnChanges {
  @Input() impresa: any = null;
  @Input() isImpresa: boolean = null;
  @Input() isPresidioTIM: boolean = null;
  @Input() isPresidioSF: boolean = null;
  @Input() isComingFromWIP: boolean = false;

  private importID: string; 

  ref: DynamicDialogRef;

  protected stats: StatsFlowdy2 = new StatsFlowdy2();
  protected praticheBando1:PraticaFlowdy2_Firestore[] ;
  protected praticheBando2:PraticaFlowdy2_Firestore[] ;
  protected praticheFiltrateBando2:PraticaFlowdy2_Firestore[] = [];
  protected praticheFiltrateBando1:PraticaFlowdy2_Firestore[] = [];
  protected praticheBando1Totali:number        = 100;
  protected praticheBando1InLavorazione:number = 20;

  protected praticheBando2Totali:number        = 200;
  protected praticheBando2InLavorazione:number = 40;

  protected isLoading:    boolean = true;
  protected isFilteringBando1:    boolean = false;
  protected filtroBando1: string = '';
  protected isFilteringBando2:    boolean = false;
  protected filtroBando2: string = '';

  protected isAdmin:      boolean = false;
  protected isSuperAdmin: boolean = false;
  protected isPM: boolean = false;
  protected isDemo: boolean = false;
  protected isDipendente: boolean = true;
  protected hasBando1: boolean    = false;
  protected hasBando2: boolean    = false;

  //private collection_pratiche:string = environment.firebase.collection_pratiche_scuola;
  private collection_pratiche:string = environment.firebase.collection_pratiche;
  private collection_prontofibra:string = environment.firebase.collection_prontofibra;
  private collection_importLog:string = environment.firebase.collection_import_log;

  //CSV BOX
  private csvbox_licenseKey_aggiornaPraticheBando1:string=environment.csvBox.secret_importaPraticheBando1Fase0;
  private csvbox_licenseKey_aggiornaPraticheBando2:string=environment.csvBox.secret_importaPraticheBando2Fase0;
  private csvbox_licenseKey_contabile_bando1:string=environment.csvBox.secret_contabile_bando1;
  private csvbox_licenseKey_contabile_bando2:string=environment.csvBox.secret_contabile_bando2;
  private csvbox_licenseKey_checkPratiche:string=environment.csvBox.secret_checkPratiche;
  private csvbox_licenseKey_aggiornaSituazioneOF:string=environment.csvBox.secret_aggiornaSituazioneOF;
  private csvbox_user:string=environment.csvBox.user;
  private csvbox_importer_aggiornaPraticheBando1:any;
  private csvbox_importer_aggiornaPraticheBando2:any;
  private csvbox_importer_aggiornaSituazioneOF:any;
  private csvbox_importer_contabile_bando1:any;
  private csvbox_importer_contabile_bando2:any;
  private csvbox_importer_checkPratiche:any;

  private unsubscribeBando1: () => void;

  constructor(
    public auth: AuthService,
    private http: HttpClient,
    private messageService: MessageService,
   
    private userService: UserService,
    public dialogService: DialogService,
    private logger: NGXLogger,
    private router: Router,
    public firestore: AngularFirestore,
    private excelService:ExcelService,
    private listService:ListeService,
  ) {}

  ngOnInit() {
    this.logger.info("[HOME DASHBOARD] ON INIT");
    this.setUserRole();
    this.initCSVBox();
  }

  setUserRole(){
    //this.logger.info(localStorage.getItem("ruolo"));
    if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "ADMIN"
    ) {
      this.isAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SUPERADMIN"
    ) {
      this.isSuperAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SMARTFIBER"
    ) {
      this.isPresidioSF = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PRESIDIO"
    ) {
      this.isPresidioTIM = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
    ) {
      this.isImpresa = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PM"
    ) {
      this.isPM = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DEMO"
    ) {
      this.isDemo = true;
    }
  }

  readImportLog(){
    const collectionRef = this.firestore.collection(this.collection_importLog).ref;
    let queryErrori ;
    queryErrori = collectionRef .where("id", "==", this.importID);
    
    onSnapshot(queryErrori, (qs) => {
      this.isLoading = false;
      qs.forEach((doc) => {
          let log: ImportLog_Firestore = doc.data() as ImportLog_Firestore;
          if(!log.errori || log.errori.length == 0){
            if(!log.warning || log.warning.length == 0){
              let messaggio:string="";
              if(log.numeroRecordNonProcessati!=0){
                if(log.numeroRecordNonProcessati==1){
                 
                    messaggio =  'Delle ' + log.numeroTotaleRecord+ ' pratiche presenti nel file ' + log.numeroRecordProcessati + ' sono state processate con successo mentre '+ log.numeroRecordNonProcessati+ ' non è stata processata.';
                  if(log.praticheSenzaODA && log.praticheSenzaODA!=0){
                    messaggio+" Inoltre"+log.praticheSenzaODA+ " pratiche risultano senza ODA."
                  } 

                  //this.messageService.add({severity:'success', summary:'', detail: 'Delle ' + log.numeroTotaleRecord+ ' pratiche presenti nel file ' + log.numeroRecordProcessati + ' sono state processate con successo mentre '+ log.numeroRecordNonProcessati+ ' non è stata processata', life:10000});

                }else {
                  messaggio =  'Delle ' + log.numeroTotaleRecord+ ' pratiche presenti nel file ' + log.numeroRecordProcessati + ' sono state processate con successo mentre '+ log.numeroRecordNonProcessati+ ' non sono state processate.';
                  if(log.praticheSenzaODA && log.praticheSenzaODA!=0){
                    messaggio+" Inoltre"+log.praticheSenzaODA+ " pratiche risultano senza ODA."
                  } 
                }
              }else{
                messaggio ='Tutte le ' + log.numeroTotaleRecord+ ' pratiche presenti nel file sono state processate con successo. ';
                if(log.praticheSenzaODA && log.praticheSenzaODA!=0){
                  messaggio+= log.praticheSenzaODA+ " pratiche però risultano senza ODA."
                } 
              }

              this.messageService.add({severity:'success', summary:'IMPORT PRATICHE', detail: messaggio, life:10000});

            }else{
              this.messageService.add({severity:'warn', summary:'Warning', detail:'Il caricamento delle pratiche si è concluso con '+ log.numeroRecordNonProcessati +' warning', life:10000});
            }
          }else{
            this.messageService.add({severity:'info', summary:'Errore', detail:'Il caricamento delle pratiche si è concluso con '+ log.numeroRecordNonProcessati +' errori', life:10000});
          }
         
          
        });
    });
    
  }

  initCSVBox(){
    this.csvbox_importer_aggiornaPraticheBando1 = new CSVBoxImporter(this.csvbox_licenseKey_aggiornaPraticheBando1, {
    }, (result: boolean, data: any) => {
      if (result) {
        this.readImportLog();
     
      } else {
        this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di AGGIORNAMENTO delle pratiche del bando 1', life:10000});
      }
    });
    this.csvbox_importer_aggiornaPraticheBando2 = new CSVBoxImporter(this.csvbox_licenseKey_aggiornaPraticheBando2, {
    }, (result: boolean, data: any) => {
     
      if (result) {
        this.readImportLog();
        //this.messageService.add({severity:'success', summary:'', detail: data.row_success + ' pratiche bando 2 AGGIORNATE con successo!', life:10000});
      } else {
        this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di AGGIORNAMENTO delle pratiche del bando 2', life:10000});
      }
    });

    this.csvbox_importer_contabile_bando1 = new CSVBoxImporter(this.csvbox_licenseKey_contabile_bando1, {
    }, (result: boolean, data: any) => {
      if (result) {
        this.readImportLog();
      } else {
        this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di AGGIORNAMENTO delle pratiche del bando 1', life:10000});
      }
    });

    this.csvbox_importer_contabile_bando2 = new CSVBoxImporter(this.csvbox_licenseKey_contabile_bando2, {
    }, (result: boolean, data: any) => {
      if (result) {
        this.readImportLog();
      }
    });

    this.csvbox_importer_checkPratiche = new CSVBoxImporter(this.csvbox_licenseKey_checkPratiche, {
    }, (result: boolean, data: any) => {
      if (result) {
        this.readImportLog();
      }
    });

    this.csvbox_importer_aggiornaSituazioneOF = new CSVBoxImporter(this.csvbox_licenseKey_aggiornaSituazioneOF, {
    }, (result: boolean, data: any) => {
      if (result) {
        this.readImportLog();
      }
    });

    this.csvbox_importer_aggiornaPraticheBando1.setUser({
      user_id: "default123"
    });
    
    this.csvbox_importer_aggiornaPraticheBando2.setUser({
      user_id: "default123"
    });

    this.csvbox_importer_contabile_bando1.setUser({
      user_id: "default123"
    });

    this.csvbox_importer_contabile_bando2.setUser({
      user_id: "default123"
    });

    this.csvbox_importer_checkPratiche.setUser({
      user_id: "default123"
    });
    this.csvbox_importer_aggiornaSituazioneOF.setUser({
      user_id: "default123"
    });

    this.csvbox_importer_aggiornaPraticheBando1.language="it";
    this.csvbox_importer_aggiornaPraticheBando2.language="it";
    this.csvbox_importer_contabile_bando1.language="it";
    this.csvbox_importer_contabile_bando2.language="it";
    this.csvbox_importer_checkPratiche.language="it";
    this.csvbox_importer_aggiornaSituazioneOF.language="it";
  
  }

  caricaCodiceBarre(){
    this.ref = this.dialogService.open(DialogCaricaCodiceBarre, {
      header: "Carica codice a barre",
      width: "50%",
      height: "50%",
    });
  }

  async loadDatiBando1(): Promise<void> {
    this.logger.info("[HOME DASHBOARD] LOAD DATI BANDO 1 INIZIO");
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando1;
    if(this.isImpresa){
      queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 1");
    }else if(this.isPresidioTIM){
      queryBando1 = collectionRef
        .where("bando", "==", "BANDO 1");
    }else {
      queryBando1 = collectionRef
        .where("bando", "==", "BANDO 1");
    }

    try {
      // Se esiste già una sottoscrizione, la annullo
      if (this.unsubscribeBando1) {
        this.unsubscribeBando1();
      }

      // Creo la nuova sottoscrizione
      this.unsubscribeBando1 = onSnapshot(queryBando1, (qs) => {
        this.stats.resetBando1();
        this.stats.bando1Totali = qs.docs.length;
        this.logger.info("[HOME DASHBOARD] LOAD DATI BANDO 1 FINE");

        this.praticheBando1 = qs.docs.map(doc => doc.data() as PraticaFlowdy2_Firestore);
        qs.forEach((doc) => {
          let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
          if(praticaBando1DaFirestore.sopralluogoOk===false || praticaBando1DaFirestore.vincoloTipologiaID){
            if(praticaBando1DaFirestore.statoPF ==='KO' || praticaBando1DaFirestore.statoPF ==='PRONTO' || praticaBando1DaFirestore.statoPF ==='ROUTER INSTALLATO'){
              this.stats.prontofibraBando1++;
              if(praticaBando1DaFirestore.lotto==='6'){
                this.stats.prontofibraBando1_lotto6++;
              }else{
                this.stats.prontofibraBando1_lotto7++;
              }
            }
            this.stats.bando1KO ++;
            if(praticaBando1DaFirestore.lotto==='6'){
              this.stats.bando1KO_lotto6++;
            }else{
              this.stats.bando1KO_lotto7++;
            }
          }else {
            if(praticaBando1DaFirestore.dataSopralluogo===null){
              if(!praticaBando1DaFirestore.showFase2){
                this.stats.bando1Fase1_sopralluogo_da_pianificare ++
              }
            }else {
              if(praticaBando1DaFirestore.statoPF ==='KO' || praticaBando1DaFirestore.statoPF ==='PRONTO' || praticaBando1DaFirestore.statoPF ==='ROUTER INSTALLATO'){
                this.stats.prontofibraBando1++;
                if(praticaBando1DaFirestore.lotto==='6'){
                  this.stats.prontofibraBando1_lotto6++;
                }else{
                  this.stats.prontofibraBando1_lotto7++;
                }
              }
              if(praticaBando1DaFirestore.statoFlowdyFase1==='SOPRALLUOGO PIANIFICATO'){
                this.stats.bando1Fase1_sopralluogo_pianificato ++;
              }else{
                if((praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-1' && !praticaBando1DaFirestore.showFase2) || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-2' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-3' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-4' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-5'){
                    this.stats.bando1Fase1_sopralluogo_effettuato ++;
                  }
              }
            }
            if( 
              ((praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-1' || 
                praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-2' || 
                praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-3' || 
                praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-4' || 
                praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-5') && praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-1' && praticaBando1DaFirestore.showFase2 ) 
              ||
              (praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-6' && (
                ( praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-1' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-2' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-3' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-4' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-5'
                )
              ) )
            ){
              this.stats.bando1Fase2 ++;
              if(!praticaBando1DaFirestore.showFase2){
                this.stats.bando1InLavorazione ++;
              }
              if(praticaBando1DaFirestore.lotto==='6'){
                this.stats.bando1Fase2_lotto6++;
              }else{
                this.stats.bando1Fase2_lotto7++;
              }
            }
            if((praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-1' && !praticaBando1DaFirestore.showFase2) || 
              praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-2' || 
              praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-3' || 
              praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-4' || 
              praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-5'){
                this.stats.bando1Fase1 ++;
                this.stats.bando1InLavorazione ++;
                if(praticaBando1DaFirestore.lotto==='6'){
                  this.stats.bando1Fase1_lotto6++;
                }else{
                  this.stats.bando1Fase1_lotto7++;
                }
            }
            if( praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-6' && 
              ( praticaBando1DaFirestore.codiceStatoInfratelFase3==='3-1' || 
              praticaBando1DaFirestore.codiceStatoInfratelFase3==='3-2' || 
              praticaBando1DaFirestore.codiceStatoInfratelFase3==='3-3' || 
              praticaBando1DaFirestore.codiceStatoInfratelFase3==='3-4' || 
              praticaBando1DaFirestore.codiceStatoInfratelFase3==='3-5')){
                this.stats.bando1Fase3 ++;
                this.stats.bando1InLavorazione ++;
                if(praticaBando1DaFirestore.lotto==='6'){
                  this.stats.bando1Fase3_lotto6++;
                }else{
                  this.stats.bando1Fase3_lotto7++;
                }
            }
          }
        });
      }, (error) => {
        this.logger.error("[HOME DASHBOARD] Errore nel caricamento dati bando 1:", error);
        throw error;
      });

    } catch (error) {
      this.logger.error("[HOME DASHBOARD] Errore nel caricamento dati bando 1:", error);
      throw error;
    }
  }

  async loadPFBando1(): Promise<void> {
    this.logger.info("[HOME DASHBOARD] LOAD PFBANDO 1 INIZIO");
    const collectionRef = this.firestore.collection(this.collection_prontofibra).ref;
    let queryBando1;
    if(this.isImpresa){
      queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 1");
    }else{
      queryBando1 = collectionRef
        .where("bando", "==", "BANDO 1");
    }

    try {
      const qs = await getDocs(queryBando1);
      this.logger.info("[HOME DASHBOARD] LOAD PFBANDO 1 FINE");

      this.stats.resetPFBando1();
      qs.forEach((doc) => {
        let pfDaFirestore: Prontofibra_Firestore = doc.data() as Prontofibra_Firestore;
        if(pfDaFirestore.codiceStatoProntofibra ==='KO' || pfDaFirestore.codiceStatoProntofibra ==='PRONTO' || pfDaFirestore.codiceStatoProntofibra ==='ROUTER INSTALLATO'){
          this.stats.prontofibraBando1++;
          if(pfDaFirestore.lotto==='6'){
            this.stats.prontofibraBando1_lotto6++;
          }else{
            this.stats.prontofibraBando1_lotto7++;
          }
        }
      });
    } catch (error) {
      this.logger.error("[HOME DASHBOARD] Errore nel caricamento PF bando 1:", error);
      throw error;
    }
  }

  async scaricaReportPreventiviOpereExtra(){
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
    this.isLoading = true;
      const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
      let query;
      query = collectionRef
      .where("bando", "==", "BANDO 2")
      .where("opereExtra", "==", true)
      .orderBy("statoPreventivo");
      const qs = await query.get();
      let praticheConPreventiviOpereExtra: PraticaFlowdy2_Firestore[] = [];
      qs.forEach((doc) => {
        let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        if(praticaBando2DaFirestore.preventivo){
          praticaBando2DaFirestore.preventivo = Number(praticaBando2DaFirestore.preventivo.toFixed(2));
          praticheConPreventiviOpereExtra.push(praticaBando2DaFirestore);

        }
      });
      this.excelService.exportPreventiviOpereExtraToExcel(praticheConPreventiviOpereExtra, `preventivi_opere_extra_bando2_${formattedDate}.xlsx`);
      this.isLoading = false;
  }

  async loadDatiBando2(): Promise<void> {
    this.logger.info("[HOME DASHBOARD] LOAD DATI BANDO 2 INIZIO");
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando2;
    if(this.isImpresa){
      queryBando2 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 2");
    }else{
      queryBando2 = collectionRef
        .where("bando", "==", "BANDO 2");
    }

    try {
      const qs = await getDocs(queryBando2);
      this.stats.resetBando2();
      this.stats.bando2Totali = qs.docs.length;
      this.logger.info("[HOME DASHBOARD] LOAD DATI BANDO 2 FINE");

      this.praticheBando2 = qs.docs.map(doc => doc.data() as PraticaFlowdy2_Firestore);
      qs.forEach((doc) => {
        let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
       
        if(praticaBando2DaFirestore.statoPF ==='KO' || praticaBando2DaFirestore.statoPF ==='PRONTO' || praticaBando2DaFirestore.statoPF ==='ROUTER INSTALLATO'){
          if(this.isImpresa){
            if(praticaBando2DaFirestore.idAziendaFase1 !== this.userService.getUser().azienda.id){
              return;
            }
          }
          this.stats.prontofibraBando2++;
          if(praticaBando2DaFirestore.lotto==='1'){
            this.stats.prontofibraBando2_lotto1++;
          }else if(praticaBando2DaFirestore.lotto==='5'){
            this.stats.prontofibraBando2_lotto5++;
          }else if(praticaBando2DaFirestore.lotto==='7'){
            this.stats.prontofibraBando2_lotto7++;
          }else {
            this.stats.prontofibraBando2_lotto8++;
          }
        }

        if(praticaBando2DaFirestore.statoFlowdyFase1!=='SOPRALLUOGO KO' &&
          ( praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-6'  || praticaBando2DaFirestore.showFase2) &&
          praticaBando2DaFirestore.codiceStatoInfratelFase2 && praticaBando2DaFirestore.codiceStatoInfratelFase2!='2-6'
        ){
          if(this.isImpresa){
            if(praticaBando2DaFirestore.idAziendaFase2 !== this.userService.getUser().azienda.id){
              return;
            }
          }
          this.stats.bando2Fase2 ++;
          this.stats.bando2InLavorazione ++;
          if(praticaBando2DaFirestore.lotto==='1'){
            this.stats.bando2Fase2_lotto1++;
          }else if(praticaBando2DaFirestore.lotto==='5'){
            this.stats.bando2Fase2_lotto5++;
          }else if(praticaBando2DaFirestore.lotto==='7'){
            this.stats.bando2Fase2_lotto7++;
          }else {
            this.stats.bando2Fase2_lotto8++;
          } 
        }

        if(praticaBando2DaFirestore.sopralluogoOk===false || praticaBando2DaFirestore.vincoloTipologiaID) {
          if(this.isImpresa){
            if(praticaBando2DaFirestore.idAziendaFase1 !== this.userService.getUser().azienda.id){
              return;
            }
          }
          this.stats.bando2KO ++;
          if(praticaBando2DaFirestore.lotto==='1'){
            this.stats.bando2KO_lotto1++;
          }else if(praticaBando2DaFirestore.lotto==='5'){
            this.stats.bando2KO_lotto5++;
          }else if(praticaBando2DaFirestore.lotto==='7'){
            this.stats.bando2KO_lotto7++;
          }else {
            this.stats.bando2KO_lotto8++;
          }
        }else{
          if(this.isImpresa){
            if(praticaBando2DaFirestore.idAziendaFase1 !== this.userService.getUser().azienda.id){
              return;
            }
          }
          if(praticaBando2DaFirestore.dataSopralluogo===null){
            if(!praticaBando2DaFirestore.showFase2){
              this.stats.bando2Fase1_sopralluogo_da_pianificare ++
            }
          }else {
            if(praticaBando2DaFirestore.statoFlowdyFase1==='SOPRALLUOGO PIANIFICATO'){
              this.stats.bando2Fase1_sopralluogo_pianificato ++;
            }else{
              if((praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-1' && !praticaBando2DaFirestore.showFase2) || 
                praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-2' || 
                praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-3' || 
                praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-4' || 
                praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-5'){
                this.stats.bando2Fase1_sopralluogo_effettuato ++;
              }
            }
          }
          if(praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-1' || 
            praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-2' || 
            praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-3' || 
            praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-4' || 
            praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-5' ){
            this.stats.bando2Fase1 ++;
            this.stats.bando2InLavorazione ++;
            if(praticaBando2DaFirestore.lotto==='1'){
              this.stats.bando2Fase1_lotto1++;
            }else if(praticaBando2DaFirestore.lotto==='5'){
              this.stats.bando2Fase1_lotto5++;
            }else if(praticaBando2DaFirestore.lotto==='7'){
              this.stats.bando2Fase1_lotto7++;
            }else {
              this.stats.bando2Fase1_lotto8++;
            } 
          }

          if(praticaBando2DaFirestore.codiceStatoInfratelFase2==='2-6' && 
            (  praticaBando2DaFirestore.codiceStatoInfratelFase3==='3-1' || 
            praticaBando2DaFirestore.codiceStatoInfratelFase3==='3-2' || 
            praticaBando2DaFirestore.codiceStatoInfratelFase3==='3-3' || 
            praticaBando2DaFirestore.codiceStatoInfratelFase3==='3-4' || 
            praticaBando2DaFirestore.codiceStatoInfratelFase3==='3-5' )){
              this.stats.bando2Fase3 ++;
              this.stats.bando2InLavorazione ++;
              if(praticaBando2DaFirestore.lotto==='1'){
                this.stats.bando2Fase3_lotto1++;
              }else if(praticaBando2DaFirestore.lotto==='5'){
                this.stats.bando2Fase3_lotto5++;
              }else if(praticaBando2DaFirestore.lotto==='7'){
                this.stats.bando2Fase3_lotto7++;
              }else {
                this.stats.bando2Fase3_lotto8++;
              } 
          }
        }
      });
    } catch (error) {
      this.logger.error("[HOME DASHBOARD] Errore nel caricamento dati bando 2:", error);
      throw error;
    }
  }

  async loadPFBando2(): Promise<void> {
    this.logger.info("[HOME DASHBOARD] LOAD PFBANDO 2 INIZIO");
    const collectionRef = this.firestore.collection(this.collection_prontofibra).ref;
    let queryBando1;
    if(this.isImpresa){
      queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 2");
    }else{
      queryBando1 = collectionRef
        .where("bando", "==", "BANDO 2");
    }

    try {
      const qs = await getDocs(queryBando1);
      this.logger.info("[HOME DASHBOARD] LOAD PFBANDO 2 FINE");

      this.stats.resetPFBando2();
      qs.forEach((doc) => {
        let pfDaFirestore: Prontofibra_Firestore = doc.data() as Prontofibra_Firestore;
        if(pfDaFirestore.codiceStatoProntofibra ==='KO' || pfDaFirestore.codiceStatoProntofibra ==='PRONTO' || pfDaFirestore.codiceStatoProntofibra ==='ROUTER INSTALLATO'){
          this.stats.prontofibraBando2++;
          if(pfDaFirestore.lotto==='1'){
            this.stats.prontofibraBando2_lotto1++;
          }else if(pfDaFirestore.lotto==='5'){
            this.stats.prontofibraBando2_lotto5++;
          }else if(pfDaFirestore.lotto==='7'){
            this.stats.prontofibraBando2_lotto7++;
          }else {
            this.stats.prontofibraBando2_lotto8++;
          }
        }
      });
    } catch (error) {
      this.logger.error("[HOME DASHBOARD] Errore nel caricamento PF bando 2:", error);
      throw error;
    }
  }

  async loadAllData(): Promise<void> {
    try {
      this.isLoading = true;
      await Promise.all([
        this.loadDatiBando1(),
        this.loadDatiBando2()
        /* ,
        this.loadPFBando1(),
        this.loadPFBando2()  */
      ]);
    } catch (error) {
      this.logger.error("[HOME DASHBOARD] Errore nel caricamento parallelo dei dati:", error);
    } finally {
      this.isLoading = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['impresa'] && changes['impresa'].currentValue) {
      this.impresa = changes['impresa'].currentValue;
    }
    if (changes['isImpresa'] && changes['isImpresa'].currentValue) {
      this.isImpresa = changes['isImpresa'].currentValue;
    }
    if (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) {
      this.isPresidioTIM = changes['isPresidioTIM'].currentValue;
    }

    if( (changes['isImpresa'] && changes['isImpresa'].currentValue) || 
        (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) || 
        (changes['impresa'] && changes['impresa'].currentValue)){
      
      // Carica i dati solo se non si arriva da WIP
      if (!this.isComingFromWIP) {
      //  this.logger.info("[HOME DASHBOARD] ON CHANGES INIZIO CON ISLOADING "+ this.isLoading);
        this.loadAllData();
       // this.logger.info("[HOME DASHBOARD] ON CHANGES FINE CON ISLOADING "+ this.isLoading);
      } else {
       // this.logger.info("[HOME DASHBOARD] Caricamento dati saltato - arrivo da WIP");
      }
    }
  }

  filtraPraticheBando2(event: any){
    if(event && event.target){
      this.logger.info('FILTRA PRATICHE BANDO 2: '+ event.target.value);
      this.filtroBando2 = event.target.value;
      this.isFilteringBando2 = true; 
      
      this.praticheFiltrateBando2 = this.praticheBando2.filter(pratica => pratica.cui.includes(event.target.value));
      if(this.praticheFiltrateBando2.length>0){
        this.stats.resetBando2();
        this.stats.resetPFBando2();
        this.stats.bando2Totali = this.praticheFiltrateBando2.length;
        this.praticheFiltrateBando2.forEach((praticaBando2DaFirestore) => {
          //let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
         
          if(praticaBando2DaFirestore.sopralluogoOk===false){
            //
            this.stats.bando2KO ++;
            if(praticaBando2DaFirestore.lotto==='1'){
              this.stats.bando2KO_lotto1++;
            }else if(praticaBando2DaFirestore.lotto==='5'){
              this.stats.bando2KO_lotto5++;
            }else if(praticaBando2DaFirestore.lotto==='7'){
              this.stats.bando2KO_lotto7++;
            }else {
              this.stats.bando2KO_lotto8++;
            }
           
          }else {
            if(praticaBando2DaFirestore.statoPF){
                this.stats.prontofibraBando2++;
                if(praticaBando2DaFirestore.lotto==='1'){
                  this.stats.prontofibraBando2_lotto1++;
                }else if(praticaBando2DaFirestore.lotto==='5'){
                  this.stats.prontofibraBando2_lotto5++;
                }else if(praticaBando2DaFirestore.lotto==='7'){
                  this.stats.prontofibraBando2_lotto7++;
                }else {
                  this.stats.prontofibraBando2_lotto8++;
                }
            }else{

            }
            

          if( 
              ((praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-1' || 
                praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-2' || 
                praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-3' || 
                praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-4' || 
                praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-5') && praticaBando2DaFirestore.codiceStatoInfratelFase2==='2-1' && praticaBando2DaFirestore.showFase2 ) 
              ||
              (praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-6' && (
                ( praticaBando2DaFirestore.codiceStatoInfratelFase2==='2-1' || 
                  praticaBando2DaFirestore.codiceStatoInfratelFase2==='2-2' || 
                  praticaBando2DaFirestore.codiceStatoInfratelFase2==='2-3' || 
                  praticaBando2DaFirestore.codiceStatoInfratelFase2==='2-4' || 
                  praticaBando2DaFirestore.codiceStatoInfratelFase2==='2-5'

                )
              ) )
              ){
              this.stats.bando2Fase2 ++;
              if(!praticaBando2DaFirestore.showFase2){
                this.stats.bando2InLavorazione ++;
              }
              
              if(praticaBando2DaFirestore.lotto==='1'){
                this.stats.bando2Fase2_lotto1++;
              }else if(praticaBando2DaFirestore.lotto==='5'){
                this.stats.bando2Fase2_lotto5++;
              }else if(praticaBando2DaFirestore.lotto==='7'){
                this.stats.bando2Fase2_lotto7++;
              }else {
                this.stats.bando2Fase2_lotto8++;
              } 
            }

           
              if((praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-1' && !praticaBando2DaFirestore.showFase2) || 
                  praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-2' || 
                  praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-3' || 
                  praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-4' || 
                  praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-5'){
                    this.stats.bando2Fase1 ++;
                    this.stats.bando2InLavorazione ++;
                    if(praticaBando2DaFirestore.lotto==='1'){
                      this.stats.bando2Fase1_lotto1++;
                    }else if(praticaBando2DaFirestore.lotto==='5'){
                      this.stats.bando2Fase1_lotto5++;
                    }else if(praticaBando2DaFirestore.lotto==='7'){
                      this.stats.bando2Fase1_lotto7++;
                    }else {
                      this.stats.bando2Fase1_lotto8++;
                    } 
              }
                 
                  
            
            if( praticaBando2DaFirestore.codiceStatoInfratelFase2==='2-6' && 
              ( praticaBando2DaFirestore.codiceStatoInfratelFase3==='3-1' || 
              praticaBando2DaFirestore.codiceStatoInfratelFase3==='3-2' || 
              praticaBando2DaFirestore.codiceStatoInfratelFase3==='3-3' || 
              praticaBando2DaFirestore.codiceStatoInfratelFase3==='3-4' || 
              praticaBando2DaFirestore.codiceStatoInfratelFase3==='3-5')){
                this.stats.bando2Fase3 ++;
                this.stats.bando2InLavorazione ++;
                if(praticaBando2DaFirestore.lotto==='1'){
                  this.stats.bando2Fase3_lotto1++;
                }else if(praticaBando2DaFirestore.lotto==='5'){
                  this.stats.bando2Fase3_lotto5++;
                }else if(praticaBando2DaFirestore.lotto==='7'){
                  this.stats.bando2Fase3_lotto7++;
                }else {
                  this.stats.bando2Fase3_lotto8++;
                } 
            }
            
          }
        });
    
      }else{
        this.stats.resetBando2();
        this.stats.resetPFBando2();
      }
      this.logger.info('PRATICHE FILTRATE: '+ this.praticheFiltrateBando2.length);
     // this.praticheDT.filterGlobal(event.target.value, 'contains');
    }else{
      this.isFilteringBando2 = false; 
      
      this.praticheFiltrateBando2 = [];
      this.stats.resetBando2();
      this.stats.resetPFBando2();
    }
  }

  filtraPraticheBando1(event: any){
    if(event && event.target){
      //if(event.target.value.length>0){
        this.logger.info('FILTRA PRATICHE: '+ event.target.value);
        this.filtroBando1 = event.target.value;
        this.isFilteringBando1 = true; 
        
      this.praticheFiltrateBando1 = this.praticheBando1.filter(pratica => pratica.cui.includes(event.target.value));
      if(this.praticheFiltrateBando1.length>0){
        this.stats.resetBando1();
        this.stats.resetPFBando1();
        this.stats.bando1Totali = this.praticheFiltrateBando1.length;
        this.praticheFiltrateBando1.forEach((praticaBando1DaFirestore) => {
          //let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        //this.logger.info("PRATICA BANDO 1 DA FIRESTORE "+ praticaBando1DaFirestore.codiceStatoInfratelFase1 + " "+ praticaBando1DaFirestore.codiceStatoInfratelFase2 + " "+ praticaBando1DaFirestore.showFase2);
          if(praticaBando1DaFirestore.sopralluogoOk===false){
            //
            this.stats.bando1KO ++;
            
            if(praticaBando1DaFirestore.lotto==='6'){
              this.stats.bando1KO_lotto6++;
            }else{
              this.stats.bando1KO_lotto7++;
            }
          }else {
            if(praticaBando1DaFirestore.statoPF){
                this.stats.prontofibraBando1++;
                if(praticaBando1DaFirestore.lotto==='6'){
                  this.stats.prontofibraBando1_lotto6++;
                }else{
                  this.stats.prontofibraBando1_lotto7++;
                }
            }else{

            }
            

          if( 
              ((praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-1' || 
                praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-2' || 
                praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-3' || 
                praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-4' || 
                praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-5') && praticaBando1DaFirestore.codiceStatoInfratelFase2!=='2-6' && praticaBando1DaFirestore.showFase2 ) 
              ||
              (praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-6' && (
                ( praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-1' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-2' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-3' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-4' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-5'

                )
              ) )
              ){
              this.stats.bando1Fase2 ++;
              if(!praticaBando1DaFirestore.showFase2){
                this.stats.bando1InLavorazione ++;
              }
              //
              if(praticaBando1DaFirestore.lotto==='6'){
                this.stats.bando1Fase2_lotto6++;
              }else{
                this.stats.bando1Fase2_lotto7++;
              }
             
            }

           
              if((praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-1' && !praticaBando1DaFirestore.showFase2) || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-2' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-3' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-4' || 
                  praticaBando1DaFirestore.codiceStatoInfratelFase1==='1-5'){
                    this.stats.bando1Fase1 ++;
           
                    this.stats.bando1InLavorazione ++;
                    if(praticaBando1DaFirestore.lotto==='6'){
                      this.stats.bando1Fase1_lotto6++;
                    }else{
                      this.stats.bando1Fase1_lotto7++;
                    }
              }
                 
                  
            
            if( praticaBando1DaFirestore.codiceStatoInfratelFase2==='2-6' && 
              ( praticaBando1DaFirestore.codiceStatoInfratelFase3==='3-1' || 
              praticaBando1DaFirestore.codiceStatoInfratelFase3==='3-2' || 
              praticaBando1DaFirestore.codiceStatoInfratelFase3==='3-3' || 
              praticaBando1DaFirestore.codiceStatoInfratelFase3==='3-4' || 
              praticaBando1DaFirestore.codiceStatoInfratelFase3==='3-5')){
                this.stats.bando1Fase3 ++;
                this.stats.bando1InLavorazione ++;
                if(praticaBando1DaFirestore.lotto==='6'){
                  this.stats.bando1Fase3_lotto6++;
                }else{
                  this.stats.bando1Fase3_lotto7++;
                }
            }
            
          }
        });
    
      }else{
        this.logger.info('0 PRATICHE RIMASTE: '+ this.praticheFiltrateBando1.length);

        this.isFilteringBando1 = false; 
        this.praticheFiltrateBando1 = [];
        this.stats.resetBando1();
        this.stats.resetPFBando1();
      }
     // this.praticheDT.filterGlobal(event.target.value, 'contains');
    }else{
      this.logger.info('PULENDO LE PRATICHE: '+ this.praticheFiltrateBando1.length);

      this.isFilteringBando1 = false; 
      
      this.praticheFiltrateBando1 = [];
      this.stats.resetBando1();
      this.stats.resetPFBando1();
    }
 
  }

  clearFiltroBando1() {
    this.filtroBando1 = '';
    this.isFilteringBando1 = false;
    this.praticheFiltrateBando1 = [];

   this.filtraPraticheBando1({ target: { value: '' } });
  }
  clearFiltroBando2() {
    this.filtroBando2 = '';
    this.isFilteringBando2 = false;
    this.praticheFiltrateBando2 = [];
    this.filtraPraticheBando2({ target: { value: '' } });
  }

  async loadDatiDashboard() {
    this.logger.info("[HOME DASHBOARD] CARICO DATI DASHBOARD INIZIO");
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    
    let queryBando1, queryBando2;
    
    if(this.isImpresa) {
      queryBando1 = collectionRef
        .where("idAzienda", "==", this.userService.getUser().azienda.id)
        .where("bando", "==", "BANDO 1");
      queryBando2 = collectionRef
        .where("idAzienda", "==", this.userService.getUser().azienda.id)
        .where("bando", "==", "BANDO 2");
    } else {
      queryBando1 = collectionRef
        .where("bando", "==", "BANDO 1");
      queryBando2 = collectionRef
        .where("bando", "==", "BANDO 2");
    }

    try {
      // Caricamento Bando 1
      this.isLoading = true;
      const bando1Snapshot = await getDocs(queryBando1);
      this.logger.info("[HOME DASHBOARD] CARICO DATI BANDO 1 FINE");
      
      // Reset e elaborazione dati Bando 1
      this.stats.resetBando1();
      this.stats.bando1Totali = bando1Snapshot.docs.length;
      bando1Snapshot.forEach((doc) => {
        let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        if(praticaBando1DaFirestore.codiceStatoInfratelFase1!=='1.6'){
          this.stats.bando1Fase1++;
          this.stats.bando1InLavorazione++;
          if(praticaBando1DaFirestore.lotto==='6'){
            this.stats.bando1Fase1_lotto6++;
          }else{
            this.stats.bando1Fase1_lotto7++;
          }
        }
        if(praticaBando1DaFirestore.codiceStatoInfratelFase2!=='2.6'){
          this.stats.bando1Fase2++;
          this.stats.bando1InLavorazione++;
          if(praticaBando1DaFirestore.lotto==='6'){
            this.stats.bando1Fase2_lotto6++;
          }else{
            this.stats.bando1Fase2_lotto7++;
          }
        }
        if(praticaBando1DaFirestore.codiceStatoInfratelFase3!=='3.6'){
          this.stats.bando1Fase3++;
          this.stats.bando1InLavorazione++;
          if(praticaBando1DaFirestore.lotto==='6'){
            this.stats.bando1Fase3_lotto6++;
          }else{
            this.stats.bando1Fase3_lotto7++;
          }
        }
      });
      this.isLoading = false;

      // Caricamento Bando 2
      this.isLoading = true;
      const bando2Snapshot = await getDocs(queryBando2);
      this.logger.info("[HOME DASHBOARD] CARICO DATI BANDO 2 FINE");
      
      // Reset e elaborazione dati Bando 2
      this.stats.resetBando2();
      this.stats.bando2Totali = bando2Snapshot.docs.length;
      bando2Snapshot.forEach((doc) => {
        let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        if(praticaBando2DaFirestore.codiceStatoInfratelFase1!=='1.6'){
          this.stats.bando2Fase1++;
          this.stats.bando2InLavorazione++;
          if(praticaBando2DaFirestore.lotto==='1'){
            this.stats.bando2Fase1_lotto1++;
          }else if(praticaBando2DaFirestore.lotto==='5'){
            this.stats.bando2Fase1_lotto5++;
          }else if(praticaBando2DaFirestore.lotto==='7'){
            this.stats.bando2Fase1_lotto7++;
          }else{
            this.stats.bando2Fase1_lotto8++;
          }
        }
        if(praticaBando2DaFirestore.codiceStatoInfratelFase2!=='2.6'){
          this.stats.bando2Fase2++;
          this.stats.bando2InLavorazione++;
          if(praticaBando2DaFirestore.lotto==='1'){
            this.stats.bando2Fase2_lotto1++;
          }else if(praticaBando2DaFirestore.lotto==='5'){
            this.stats.bando2Fase2_lotto5++;
          }else if(praticaBando2DaFirestore.lotto==='7'){
            this.stats.bando2Fase2_lotto7++;
          }else{
            this.stats.bando2Fase2_lotto8++;
          }
        }
        if(praticaBando2DaFirestore.codiceStatoInfratelFase3!=='3.6'){
          this.stats.bando2Fase3++;
          this.stats.bando2InLavorazione++;
          if(praticaBando2DaFirestore.lotto==='1'){
            this.stats.bando2Fase3_lotto1++;
          }else if(praticaBando2DaFirestore.lotto==='5'){
            this.stats.bando2Fase3_lotto5++;
          }else if(praticaBando2DaFirestore.lotto==='7'){
            this.stats.bando2Fase3_lotto7++;
          }else{
            this.stats.bando2Fase3_lotto8++;
          }
        }
      });
      this.isLoading = false;

      this.logger.info("[HOME DASHBOARD] CARICO DATI DASHBOARD FINE");
    } catch (error) {
      this.isLoading = false;
      this.logger.error("[HOME DASHBOARD] Errore nel caricamento dei dati:", error);
    }
  }

  openPraticheBando(bando:number, fase:string){
    this.logger.info("--> openPraticheBando "+ fase);
    if(fase==='fase-1' || fase==='fase-2' || fase==='fase-3' || fase==='ko'){
      if(this.isFilteringBando1 || this.isFilteringBando2){
        this.logger.info("APRO PRATICA CON FILTRO SU PRATICA "+ this.filtroBando1 + " " + this.filtroBando2);
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/'+fase],
          {
            queryParams: { 
               // 'bando': bando,
              //  'pratica': this.filtroBando1,
            //    'pratica': bando===1 ? this.praticheFiltrateBando1[0].cui : this.praticheFiltrateBando2[0].cui,
                'pratica': bando===1 ? this.filtroBando1 : this.filtroBando2,
                }, 
          })
        );
      }else{
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/'+fase]));
      }
      
    }else if(fase==='PF'){
     
      if(this.isFilteringBando1 || this.isFilteringBando2){
        this.logger.info("APRO PF CON FILTRO SU PRATICA "+ this.filtroBando1 + " / " + this.filtroBando2);
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['prontofibra'],
          {
            queryParams: { 
               // 'bando': bando,
               'pratica': bando===1 ? this.filtroBando1 : this.filtroBando2,
                }, 
          })
        );
      }else{
        this.logger.info("APRO PF SENZA FILTRO");
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['prontofibra'],
          {
            queryParams: { 
                'bando': bando,
                }, 
          })
        );
      }
      

      
    }
  }
  async scaricaAnagraficaPraticheBando1(){
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
    this.isLoading = true;
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando1  ;
    if(this.isImpresa){
      queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 1")
                    .orderBy("codiceStatoInfratelFase1")
                    .orderBy("statoFlowdyFase1")
                    .orderBy("codiceStatoInfratelFase2")
                    .orderBy("statoFlowdyFase2")
                    .orderBy("codiceStatoInfratelFase3")
                    .orderBy("statoFlowdyFase3")
                    ;

    }else{
      
        queryBando1 = collectionRef
        .where("bando", "==", "BANDO 1")
        .orderBy("codiceStatoInfratelFase1")
        .orderBy("statoFlowdyFase1")
        .orderBy("codiceStatoInfratelFase2")
        .orderBy("statoFlowdyFase2")
        .orderBy("codiceStatoInfratelFase3")
        .orderBy("statoFlowdyFase3")
        ;

      
     
    }
    try {
      const qs = await getDocs(queryBando1);
      this.isLoading = false;
  
      let pratichePerExportNonOrdinate: PraticaFlowdy2_Firestore[] = [];
      qs.forEach((doc) => {
        let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        pratichePerExportNonOrdinate.push(praticaBando1DaFirestore);
      });

       this.excelService.exportAnagraficaBando1ToExcel(pratichePerExportNonOrdinate, `anagrafica_BANDO1_${formattedDate}.xlsx`);
      

      
    } catch (error) {
      this.isLoading = false;
      console.error('Errore durante l\'esportazione delle pratiche:', error);
    }
  }

  async allineaBando1(){
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando1  = collectionRef
    .where("bando", "==", "BANDO 1")
    .where("codiceStatoInfratelFase1", "==", "1-6")
    .where("dataSopralluogo", "!=", null)
    .where("sopralluogoOk", "==", false);
    try {
      const qs = await getDocs(queryBando1);
      this.logger.info('[ALLINEAMENTO] DATI ARRIVATI PER BANDO 1: '+ qs.docs.length);
      const updatePromises: Promise<void>[] = [];

      qs.forEach((doc) => {
        let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        this.logger.info(doc.id +  " > " + praticaBando1DaFirestore.cui + " > "+ praticaBando1DaFirestore.dataSopralluogo + " > " + praticaBando1DaFirestore.sopralluogoOk);
        // Creiamo una promessa di aggiornamento e la aggiungiamo alla lista
         const updatePromise = this.firestore.collection(this.collection_pratiche)
        .doc(doc.id)
        .update({ sopralluogoOk: true }); 

        updatePromises.push(updatePromise);
      });
      await Promise.all(updatePromises);
      this.logger.info('[ALLINEAMENTO] Aggiornamento di '+ updatePromises.length + ' documenti completato con successo ' );

      
    } catch (error) {
      this.isLoading = false;
      console.error('Errore durante l\'esportazione delle pratiche:', error);
    }
  }


  


  async allineaBando2(){
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando1  = collectionRef
    .where("bando", "==", "BANDO 2")
    .where("codiceStatoInfratelFase1", "==", "1-6")
    .where("dataSopralluogo", "!=", null)
    .where("sopralluogoOk", "==", false);
    try {
      const qs = await getDocs(queryBando1);
      this.logger.info('[ALLINEAMENTO] DATI ARRIVATI PER BANDO 2: '+ qs.docs.length);
      const updatePromises: Promise<void>[] = [];

      qs.forEach((doc) => {
        let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        this.logger.info(praticaBando2DaFirestore.cui );
         const updatePromise = this.firestore.collection(this.collection_pratiche)
        .doc(doc.id)
        .update({ sopralluogoOk: true }); 

        updatePromises.push(updatePromise); 
      });
      await Promise.all(updatePromises);
      this.logger.info('[ALLINEAMENTO] Aggiornamento di '+ updatePromises.length + ' documenti completato con successo ' );

      
    } catch (error) {
      this.isLoading = false;
      console.error('Errore durante l\'esportazione delle pratiche:', error);
    }
  }

  async scaricaAnagraficaPraticheBando2(){
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
    this.isLoading = true;
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando1  ;
    if(this.isImpresa){
      queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 2")
                    .orderBy("codiceStatoInfratelFase1")
                    .orderBy("statoFlowdyFase1")
                    .orderBy("codiceStatoInfratelFase2")
                    .orderBy("statoFlowdyFase2")
                    .orderBy("codiceStatoInfratelFase3")
                    .orderBy("statoFlowdyFase3");

    }else {
      
        queryBando1 = collectionRef
        .where("bando", "==", "BANDO 2")
        .orderBy("codiceStatoInfratelFase1")
        .orderBy("statoFlowdyFase1")
        .orderBy("codiceStatoInfratelFase2")
        .orderBy("statoFlowdyFase2")
        .orderBy("codiceStatoInfratelFase3")
        .orderBy("statoFlowdyFase3");
      
     
    }
    try {
      const qs = await getDocs(queryBando1);
      this.isLoading = false;
  
      let pratichePerExportNonOrdinate: PraticaFlowdy2_Firestore[] = [];
      qs.forEach((doc) => {
        let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        pratichePerExportNonOrdinate.push(praticaBando2DaFirestore);
      });
     
        this.excelService.exportAnagraficaBando2ToExcel(pratichePerExportNonOrdinate, `anagrafica_BANDO2_${formattedDate}.xlsx`);

      
    } catch (error) {
      this.isLoading = false;
      console.error('Errore durante l\'esportazione delle pratiche:', error);
    }
  }


  async scaricaReportPraticheBando1(){
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
    this.isLoading = true;
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando1  ;
    if(this.isImpresa){
      queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 1")
                    .orderBy("codiceStatoInfratelFase1")
                    .orderBy("statoFlowdyFase1")
                    .orderBy("codiceStatoInfratelFase2")
                    .orderBy("statoFlowdyFase2")
                    .orderBy("codiceStatoInfratelFase3")
                    .orderBy("statoFlowdyFase3")
                    ;

    }else{
      
        queryBando1 = collectionRef
        .where("bando", "==", "BANDO 1")
        .orderBy("codiceStatoInfratelFase1")
        .orderBy("statoFlowdyFase1")
        .orderBy("codiceStatoInfratelFase2")
        .orderBy("statoFlowdyFase2")
        .orderBy("codiceStatoInfratelFase3")
        .orderBy("statoFlowdyFase3")
        ;

      
     
    }
    try {
      const qs = await getDocs(queryBando1);
      this.isLoading = false;
  
      let pratichePerExportNonOrdinate: PraticaFlowdy2_Firestore[] = [];
      qs.forEach((doc) => {
        let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        pratichePerExportNonOrdinate.push(praticaBando1DaFirestore);
      });

      if(this.isImpresa){
        this.excelService.exportAllPraticheBando1ImpreseToExcel(pratichePerExportNonOrdinate, `pratiche_BANDO1_${formattedDate}.xlsx`);
      }else{
        this.excelService.exportAllPraticheBando1ToExcel(pratichePerExportNonOrdinate, `pratiche_BANDO1_${formattedDate}.xlsx`);
      }

      
    } catch (error) {
      this.isLoading = false;
      console.error('Errore durante l\'esportazione delle pratiche:', error);
    }
    /* onSnapshot(queryBando1, (qs) => {
      this.isLoading = false;
      let pratichePerExportNonOrdinate:PraticaFlowdy2_Firestore[]=[];
      qs.forEach((doc) => {
        let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        pratichePerExportNonOrdinate.push(praticaBando2DaFirestore);
      });
       
      this.excelService.exportAllPraticheBando1ToExcel(pratichePerExportNonOrdinate, `pratiche_BANDO1_${formattedDate}.xlsx`);

    }); */
  }

  async scaricaReportPraticheBando2(){
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
    this.isLoading = true;
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando1  ;
    if(this.isImpresa){
      queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 2")
                    .orderBy("codiceStatoInfratelFase1")
                    .orderBy("statoFlowdyFase1")
                    .orderBy("codiceStatoInfratelFase2")
                    .orderBy("statoFlowdyFase2")
                    .orderBy("codiceStatoInfratelFase3")
                    .orderBy("statoFlowdyFase3");

    }else {
      
        queryBando1 = collectionRef
        .where("bando", "==", "BANDO 2")
        .orderBy("codiceStatoInfratelFase1")
        .orderBy("statoFlowdyFase1")
        .orderBy("codiceStatoInfratelFase2")
        .orderBy("statoFlowdyFase2")
        .orderBy("codiceStatoInfratelFase3")
        .orderBy("statoFlowdyFase3");
      
     
    }
    try {
      const qs = await getDocs(queryBando1);
      this.isLoading = false;
  
      let pratichePerExportNonOrdinate: PraticaFlowdy2_Firestore[] = [];
      qs.forEach((doc) => {
        let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        pratichePerExportNonOrdinate.push(praticaBando2DaFirestore);
      });
      if(this.isImpresa){
        this.excelService.exportAllPraticheBando2ImpreseToExcel(pratichePerExportNonOrdinate, `pratiche_BANDO2_${formattedDate}.xlsx`);

      }
      else{
        this.excelService.exportAllPraticheBando2ToExcel(pratichePerExportNonOrdinate, `pratiche_BANDO2_${formattedDate}.xlsx`);

      }
    } catch (error) {
      this.isLoading = false;
      console.error('Errore durante l\'esportazione delle pratiche:', error);
    }
  }

  openPraticheBandoPerLotto(bando:number, fase:string, lotto:string){
    if(fase==='fase-1' || fase ==='fase-2' || fase ==='fase-3' || fase==='ko'){
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/'+fase+"/lotto/"+lotto]));
   }else if(fase==='PF'){
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['prontofibra'],
        {
          queryParams: { 
              'bando': bando,
              'lotto':lotto,
              }, 
        })
      );
    }
  }

  aggiornaSituazioneOF(){
    this.importID = uuidv4();
    this.csvbox_importer_aggiornaSituazioneOF.setUser({
      importID: this.importID,
    });
    this.csvbox_importer_aggiornaSituazioneOF.openModal();
  }

  aggiornaPratiche(bando:number){
    this.importID = uuidv4();
    if(bando===1){
      this.csvbox_importer_aggiornaPraticheBando1.setUser({
        importID: this.importID,
      });
      this.csvbox_importer_aggiornaPraticheBando1.openModal();
    }else if(bando===2){
      this.csvbox_importer_aggiornaPraticheBando2.setUser({
        importID: this.importID,
      });
      this.csvbox_importer_aggiornaPraticheBando2.openModal();
    }
  }

  aggiornaContabile(bando:number){
    this.importID = uuidv4();
    if(bando===1){
      this.csvbox_importer_contabile_bando1.setUser({
        importID: this.importID,
      });
      this.csvbox_importer_contabile_bando1.openModal();
    }else if(bando===2){
      this.csvbox_importer_contabile_bando2.setUser({
        importID: this.importID,
      });
      this.csvbox_importer_contabile_bando2.openModal();
    }
    
  }

  checkPratiche(){
    this.importID = uuidv4();
    this.csvbox_importer_checkPratiche.setUser({
      importID: this.importID,
    });
    this.csvbox_importer_checkPratiche.openModal();
    
  }
  
  ngOnDestroy() {
    if (this.unsubscribeBando1) {
      this.unsubscribeBando1();
    }
  }
}
